import React from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogContent,
  Slide,
  DialogTitle,
  IconButton,
} from "@material-ui/core";

// import CompletedIcon from "../../assets/icons/completed.svg";
import { ReactComponent as CompletedIconSvg } from "../../assets/icons/completed-2.svg";

import { withStyles } from "@material-ui/core/styles";
import Button from "../stake/components/Button";
import Spinner from "../stake/components/Spinner";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    position: "relative",
  },
  modalContent: {
    // Your content styles
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  waitingForConfirmationContainer: {
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "auto",
    marginTop: "62px",
  },
  completedIcon: {
    height: "120px",
    width: "120px",
    color: "#00bb1c",
  },
  waitingForConfirmationText: {
    color: theme?.colors?.presale?.cardTitle,
    fontWeight: "600",
    fontSize: "24px",
    marginTop: "32px",
  },

  manageModalContent: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "34px !important",
    padding: "32px 48px 24px 48px",
    position: "relative",
    height: "430px",
  },
  manageModalBg: {
    background: "#ffffff 0% 0% no-repeat padding-box",
    borderRadius: "34px",
    opacity: 0.09,
    position: "absolute",
    top: "4px",
    left: "0px",
    right: "7px",
    bottom: "6px",
    zIndex: 0,
  },
  manageModalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
    marginBottom: "20px",
  },
  confirmationModalHeadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginBottom: "15px",
    padding: "15px",
  },
  manageModalHeadingLogoName: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  manageModalHeadingLogo: {
    width: "35px",
    height: "35px",
    objectFit: "contain",
    marginRight: "5px",
  },
  manageModalHeadingAddress: {
    flex: 1,
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "1.35px",
    color: "#8bf5ff",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  manageModalHeadingLg: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "27px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textTransform: "capitalize",
    marginTop: "4px",
  },
  manageModalCloseIcon: {
    width: "28px",
    height: "28px",
    position: "absolute",
    top: "25px",
    right: "25px",
    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  paper: {
    background: theme?.colors?.swap?.background,
    borderRadius: "30px",
    boxShadow:
      "0px 10px 60px " + theme?.colors?.containerShadow + " !important",
  },
  modalRoot: {
    maxWidth: "640px",
    [theme.breakpoints.up("md")]: {
      borderRadius: "30px",
    },
  },
  manageModalBody: {
    zIndex: 1,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "20px",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  manageModalNameInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: "10px 0px",
  },
  manageModalHeadingMd: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textTransform: "uppercase",
    marginBottom: "10px",
  },

  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
  },
  modalHeadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    padding: "8px 24px 0px",
  },
  modalHeadingLogoName: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  modalLg: {
    maxWidth: "553px",
  },
  modalHeadingLogo: {
    width: "35px",
    height: "35px",
    objectFit: "contain",
    marginRight: "5px",
  },
  modalHeadingLg: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "25px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textTransform: "capitalize",
    fontWeight: 600,
  },
  modalCloseIcon: {
    width: "28px",
    height: "28px",
    position: "absolute",
    top: "25px",
    right: "25px",
    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  buttonsContainer: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginTop: "auto",
    // marginTop: "48px",
    // [theme.breakpoints.down("sm")]: {
    //   marginTop: "24px",
    // },
  },
  manageModalText: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    marginBottom: "20px",
  },
  manageModalSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    height: "65px",
    marginBottom: "40px",
  },
  manageModalHeadingSm: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  manageModalNameId: {
    padding: "10px 20px 6px 20px",
    background: "#A0A0A0 0% 0% no-repeat padding-box",
    borderRadius: "8px",
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  manageModalSell: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    padding: "10px 0px",
  },
  confirmationModalBody: {
    zIndex: 1,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingInfoList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "0px 15px",
  },
  stakingHeading: {
    display: "flex",
    width: "100%",
    marginBottom: "15px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingLine: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  stakingIndex: {
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: "#A0A0A0",
  },
  stakingValue: {
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingModeContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "35px",
    gap: "38px",
  },
  stakingModeLabel: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "27px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
  },
  stakingModeLabelSelected: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "27px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    borderBottom: "2px solid " + theme?.colors?.presale?.cardTitle,
  },
  stakingInputContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginBottom: "20px",
  },
  stakingLockContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  stakingLockLabelValues: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  stakingLabel: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: "#A0A0A0",
  },
  stakingLabelBold: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingLockSlider: {
    width: "100%",
    marginBottom: "50px",
  },
  stakingAmountInputBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingAmountLabels: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  textInput: {
    background: "transparent",
    border: "2px solid" + theme?.colors?.createPool?.inputBorder,
    color: theme?.colors?.createPool?.inputLabel,

    width: "100%",
    borderRadius: "20px",
    padding: "16px",
  },
  stakingAmountLine: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    marginBottom: "10px",
  },
  stakingMaxButton: {
    position: "absolute",
    right: "16px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
    "&:hover": {
      color: theme?.colors?.presale?.cardTitle,
    },
  },
  stakingAmountApy: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: "20px",
  },
  stakingTipText: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    maxWidth: "240px",
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const ConfirmationModal = ({
  modalOpen,
  onClose,
  showSuccessModal,
  classes,
}) => {
  return (
    <Dialog
      classes={{ paper: classes.paper, paperWidthSm: classes.modalRoot }}
      open={modalOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="staking-modal-title"
      aria-describedby="staking-modal-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle disableTypography className={classes.modalHeader}>
        <IconButton
          aria-label="close"
          className={classes.modalCloseIcon}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.manageModalContent}>
        {showSuccessModal ? (
          <div className={classes.waitingForConfirmationContainer}>
            <CompletedIconSvg className={classes.completedIcon} />

            <p className={classes.waitingForConfirmationText}>
              Transaction completed
            </p>

            <div className={classes.buttonsContainer}>
              <Button
                classes={{
                  root: classes.poolButton,
                  label: classes.buttonLabel,
                }}
                onClick={onClose}
                text="Close"
              />
            </div>
          </div>
        ) : (
          <div className={classes.waitingForConfirmationContainer}>
            <Spinner />
            <p className={classes.waitingForConfirmationText}>
              Waiting for confirmation
            </p>

            <div className={classes.buttonsContainer}>
              <Button
                classes={{
                  root: classes.poolButton,
                  label: classes.buttonLabel,
                }}
                onClick={onClose}
                text="Close"
              />
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default withNamespaces()(
  withRouter(withStyles(styles)(ConfirmationModal))
);
